module.exports = __webpack_public_path__ + "img/circle-off-outline.944a6a7f.svg";